export default __webpack_public_path__ + "static/media/box-blog.7d6e046f.jpeg";